import React from 'react';
import PageFrame from './PageFrame';
import resolveTemplateHeader, { mergeFamilyHeaderChrome } from './resolveTemplateHeader';
import { ShellChromeProvider } from './ShellChromeContext';

/**
 * ObjectPageSection — facet block inside ObjectPageTemplate.
 */
export const ObjectPageSection = ({
  children,
  className = '',
  title,
  actions,
  header,
}) => (
  <section
    className={['ads-screen-object__section', 'ads-panel', className].filter(Boolean).join(' ')}
  >
    {header ?? (title || actions ? (
      <header className="ads-screen-object__section-header ads-panel__header">
        {title ? <h2 className="ads-type-section">{title}</h2> : null}
        {actions ? (
          <div className="ads-screen-object__section-actions">{actions}</div>
        ) : null}
      </header>
    ) : null)}
    <div className="ads-screen-object__section-body">{children}</div>
  </section>
);

/**
 * ObjectPageTemplate — Fiori Object Page (entity detail / editor).
 * Header → optional tabs → sections → sticky footer actions.
 */
const ObjectPageTemplate = ({
  children,
  className = '',
  dir,
  wide = false,
  measure = 'reading',
  header,
  familyHeader,
  title,
  subtitle,
  headerActions,
  tabs,
  sections,
  footerActions,
  content,
}) => {
  const mergedFamilyHeader = mergeFamilyHeaderChrome(familyHeader, {});
  const resolvedHeader = resolveTemplateHeader({
    header,
    familyHeader: mergedFamilyHeader,
    title,
    subtitle,
    headerActions,
  });

  return (
  <ShellChromeProvider titleOwned={Boolean(familyHeader)}>
  <PageFrame
    className={['ads-screen-object', className].filter(Boolean).join(' ')}
    dir={dir}
    wide={wide}
    measure={measure}
  >
    {resolvedHeader}
    {tabs || null}
    <div className="ads-screen-object__body">
      {sections}
      {content ?? children}
    </div>
    {footerActions ? (
      <div className="ads-screen-form__actions ads-screen-object__actions">
        {footerActions}
      </div>
    ) : null}
  </PageFrame>
  </ShellChromeProvider>
  );
};

export default ObjectPageTemplate;
